/**
 * SubscriptionStatusBanner — shows a warning when subscription is past_due or canceled.
 * Renders nothing for active/trialing subscriptions.
 */

import { Link } from "react-router-dom";
import type { Subscription } from "../api/types.js";

interface SubscriptionStatusBannerProps {
  subscription: Subscription | null | undefined;
}

export function SubscriptionStatusBanner({
  subscription,
}: SubscriptionStatusBannerProps) {
  if (subscription?.status === "past_due") {
    return (
      <div
        className="subscription-banner subscription-banner--warning"
        role="alert"
      >
        <span>
          Your payment failed. Please{" "}
          <Link to="/billing" className="subscription-banner__link">
            update your payment method
          </Link>{" "}
          to avoid losing access.
        </span>
      </div>
    );
  }

  if (subscription?.status === "canceled") {
    return (
      <div
        className="subscription-banner subscription-banner--danger"
        role="alert"
      >
        <span>
          Your subscription has been canceled.{" "}
          <Link to="/billing" className="subscription-banner__link">
            Renew
          </Link>{" "}
          to continue scanning.
        </span>
      </div>
    );
  }

  return null;
}
